<div class="container">
  <div class="row">
    <div class="card full-width-card">
      <div class="card-body">
        @if (!enableText) {
        <p>
          {{
            (ltssSwitch ? "COMMUNICATION_DESC_LTSS" : "COMMUNICATION_DESC")
              | globalTranslate
          }}
        </p>
        } @if (enableText) {
        <p>
          {{
            (ltssSwitch
              ? "COMMUNICATION_DESC_PP_LTSS"
              : "COMMUNICATION_DESC_PP"
            ) | globalTranslate
          }}
        </p>
        } @if (!enableText) {
        <p>{{ "COMMUNICATION_DESC_2" | globalTranslate }}</p>
        } @if (enableText) {
        <p>{{ "COMMUNICATION_DESC_2_PP" | globalTranslate }}</p>
        } @if (res) {
        <form #communicationForm="ngForm">
          <h1 class="section-header">
            {{ "COMMUNICATION_HEADER" | globalTranslate }}
          </h1>
          <hr />
          <div class="d-flex form-switch align-items-center switch-control">
            <div class=" ">
              <input
                type="checkbox"
                [disabled]="isDisabled"
                tabindex="0"
                class="form-check-input"
                name="mail"
                (change)="communicationFormCheck(communicationForm)"
                [(ngModel)]="res.paperSw"
                id="customSwitch1"
              />
              <label class="custom-control-label ms-2" for="customSwitch1"
                >{{ "COMMUNICATION_MAIL" | globalTranslate }}.</label
              >
            </div>
          </div>
          <h2 class="section-header mt-3">
            {{ "COMMUNICATION_HEADER2" | globalTranslate }}
          </h2>
          <hr />
          <p class="mt-1">{{ "COMMUNICATION_EMAIL_DESC" | globalTranslate }}</p>
          <div class="d-flex form-switch align-items-center switch-control">
            <div class="">
              <input
                type="checkbox"
                [disabled]="isDisabled"
                role="switch"
                tabindex="0"
                class="form-check-input"
                name="email"
                #emailPref
                (change)="communicationFormCheck(communicationForm)"
                [(ngModel)]="res.emailSw"
                id="customSwitch2"
              />
              <label class="custom-control-label ms-2" for="customSwitch2"
                >{{ "COMMUNICATION_EMAIL" | globalTranslate }}.</label
              >
            </div>
            <span>
              <nh-popover
                class="pl-1"
                content="{{ 'COMMUNICATION_EMAIL_TOOLTIP' | globalTranslate }}"
              >
              </nh-popover>
            </span>
          </div>
          @if (res.emailSw && !enableText) {
          <div class="m-3 pl-4">{{ emailId }}</div>
          } @if (res.emailSw && enableText) {
          <div class="m-3 pl-4">{{ emailAddress }}</div>
          }
          <p class="mt-2">
            {{ "COMMUNICATION_EMAIL_DESC_1" | globalTranslate }}
          </p>
          <h2 class="section-header">
            {{ "COMMUNICATION_HEADER3" | globalTranslate }}
          </h2>
          <hr />
          <p class="mt-1">{{ "COMMUNICATION_TEXT_DESC" | globalTranslate }}</p>
          <div class="d-flex form-switch align-items-center switch-control">
            <div class="">
              <input
                type="checkbox"
                [disabled]="isDisabled"
                class="form-check-input"
                tabindex="0"
                name="text"
                #textPref
                (change)="communicationFormCheck(communicationForm)"
                [(ngModel)]="res.textSw"
                id="customSwitch3"
              />
              <label class="custom-control-label ms-2" for="customSwitch3"
                >{{ "COMMUNICATION_TEXT" | globalTranslate }}.</label
              >
            </div>
          </div>
          @if (res.textSw) {
          <div class="m-3 pl-4 d-flex">
            @if (!onEdit && enterPhone) {
            <div class="mr-5 mt-2">
              {{ res.phoneNumber | phone }}
            </div>
            } @if (!enterPhone || onEdit) {
            <div layout-align="start center" class="mr-4 mt-1">
              <input
                type="phone"
                [disabled]="isDisabled"
                name="phone"
                class="form-control"
                [(ngModel)]="res.phoneNumber"
                minlength="10"
                mask="000-000-0000"
                placeholder="XXX-XXX-XXXX"
                (change)="onChange(res.phoneNumber)"
                (focusout)="communicationFormCheck(communicationForm)"
                required
              />
              @if (ifRequired) {
              <span
                role="alert"
                aria-live="assertive"
                class="invalid-name d-block"
                >{{ "PHONE_NUMBER" | globalTranslate }}</span
              >
              }
            </div>
            }
            <button
              class="btn-phone-edit"
              [disabled]="isDisabled"
              (click)="onEdit = true"
            >
              <span>{{ "EDIT_BUTTON" | globalTranslate }}</span>
            </button>
          </div>
          }
          <div class="small mt-4 mb-4">
            <strong>{{
              "COMMUNICATION_NOTIFICATION_HEADER" | globalTranslate
            }}</strong
            >{{ "COMMUNICATION_NOTIFICATION" | globalTranslate }}
          </div>
          <nh-alert type="warning" [isOpen]="isCancelClicked">
            <div class="row">
              <div class="col-auto icon">
                <img
                  src="../../../../../assets/images/Icons/⚛️ icons-warning-outline.svg"
                  alt=""
                />
              </div>
              <div class="col message">
                <span class="visually-hidden"
                  >{{ "Alert" | globalTranslate }}
                </span>
                <span>{{ "WARNING_CANCEL" | globalTranslate }}</span>
              </div>
            </div>
          </nh-alert>
        </form>
        }
      </div>
    </div>
  </div>
</div>